import { render, staticRenderFns } from "./QuestionCourses.vue?vue&type=template&id=5e541bfa&scoped=true&"
import script from "./QuestionCourses.vue?vue&type=script&lang=ts&"
export * from "./QuestionCourses.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionCourses.vue?vue&type=style&index=0&id=5e541bfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e541bfa",
  null
  
)

export default component.exports